import { createAsyncThunk } from '@reduxjs/toolkit';
import checklistApi from '~/apis/checklist';
import { IChecklistForm, IFormCheckListItem, IQueryParamChecklist } from '~/utils/interface/checklist';
import {
  CREATE_CHECKLIST,
  CREATE_CHECKLIST_ITEM,
  DELETE_CHECKLIST,
  DELETE_CHECKLIST_ITEM,
  GET_CHECKLIST,
} from '~/utils/constants/actionType';

export const getChecklist = createAsyncThunk(
  GET_CHECKLIST,
  async (params: IQueryParamChecklist, { rejectWithValue }) => {
    try {
      const resp = await checklistApi.getChecklist(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createChecklist = createAsyncThunk(CREATE_CHECKLIST, async (body: IChecklistForm, { rejectWithValue }) => {
  try {
    const resp = await checklistApi.createChecklist(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteChecklist = createAsyncThunk(DELETE_CHECKLIST, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await checklistApi.deleteChecklist(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createChecklistItem = createAsyncThunk(
  CREATE_CHECKLIST_ITEM,
  async (body: IFormCheckListItem, { rejectWithValue }) => {
    try {
      const resp = await checklistApi.createChecklistItem(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteChecklistItem = createAsyncThunk(DELETE_CHECKLIST_ITEM, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await checklistApi.deleteChecklistItem(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
